export class ImageUploadPreviewComponent {

    private _inputSelector: string = null;
    private _previewSelector: string = null;

    private _input: JQuery = null;
    private _preview: JQuery = null;
    private _previewImage: JQuery = null;

    private bindEvents(): void {
        this._input.on("change", (event: Event) => {
            const value = this._input.val() as string;
            if (value.length) {
                const inputTarget = event.target as HTMLInputElement;
                this._previewImage.attr("src", URL.createObjectURL(inputTarget.files.item(0)));
                this._preview.show();
            } else {
                this._preview.hide();
            }
        });
    }

    private parseContext(): void {
        this._input = $(this._inputSelector);
        this._preview = $(this._previewSelector);
        this._previewImage = $("img", this._previewSelector);
    }

    public init(inputSelector: string, previewSelector: string): void {
        this._inputSelector = inputSelector || this._inputSelector;
        this._previewSelector = previewSelector || this._previewSelector;

        this.parseContext();
        this.bindEvents();
    }

    public static init(inputSelector: string, previewSelector: string): ImageUploadPreviewComponent {
        const component = new ImageUploadPreviewComponent();
        component.init(inputSelector, previewSelector);
        return component;
    }
}
